import React from "react";
import { Routes, Route } from "react-router-dom";
import StudentSidebar from "../../../components/student/StudentSidebar";
import AllProjects from "../../common-pages/all-projects-page/AllProjects";
import OngoingProjects from "../ongoing-projects/OngoingProjects";
import EditProfile from "../profile-details/EditProfile";
import Error404 from "../../errors/Error404";
import ProfilePageProjects from "../../common-pages/ProfilePageProjects";
import StarredProjects from "../../common-pages/StarredProjects";
import { ProjectDetailsPage } from "../../common-pages/project-details-page/ProjectDetailsPage";

const StudentContainer = () => {
  return (
    <>
      <div className="flex flex-row">
        <div className="h-screen sticky top-0 left-0 hidden lg:flex">
          <StudentSidebar />
        </div>
        <Routes>
          <Route path="all-projects" element={<AllProjects />} />
          <Route path="ongoing-projects" element={<OngoingProjects />} />
          <Route
            path="completed-projects"
            element={<ProfilePageProjects role={"student"} />}
          />
          <Route
            path="starred-projects"
            element={<StarredProjects role={"student"} />}
          />
          <Route
            path="project-details/:projectId"
            element={<ProjectDetailsPage />}
          />
          <Route path="profile-details" element={<EditProfile />} />
          <Route
            path="*"
            element={<Error404 tabTitle="404 Page Not Found" />}
          />
        </Routes>
      </div>
    </>
  );
};

export default StudentContainer;
